const path = {
  login: '/login',
  enroll: '/enroll',
  profile: '/profile',
  sso: '/sso-silent',
  invitation: '/invitation',
  businesses: '/business-list',
  terms: '/terms-of-use',
  privacy: '/privacy-policy',
  eSign: '/e-sign-consent',
  callback: '/callback',
  dashboard: '/',
} as const;

type PathType = typeof path;

export type Paths = PathType[keyof PathType];

export default path;
